export default __webpack_public_path__ + "static/media/B01.b38f173b.png";